import { render, staticRenderFns } from "./DishSales.vue?vue&type=template&id=65c48004&scoped=true&"
import script from "./DishSales.vue?vue&type=script&lang=js&"
export * from "./DishSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c48004",
  null
  
)

export default component.exports